import React, { useState } from "react";
import "./Contact.css";
import cont from "../../../images/medical-team-yitalife-kampala.jpeg";
import contFallback from "../../../images/11.jpg";
import heroContactImg from "../../../images/community-health-outreach-kampala.jpeg";
import { Link } from "react-router-dom";
import Api from "../../../Data/Api";
import PageSEO from "../../SEO/PageSEO";

const contactDetails = [
  {
    icon: "location-outline",
    label: "Address",
    value: "Makerere Kavule, Phlona Medical Chambers, Kampala, Uganda",
  },
  {
    icon: "call-outline",
    label: "Phone",
    value: "+256 777 114 327",
    href: "tel:+256777114327",
  },
  {
    icon: "mail-outline",
    label: "Email",
    value: "info@yitalife.com",
    href: "mailto:info@yitalife.com",
  },
  {
    icon: "alarm-outline",
    label: "Hours",
    value: "Mon-Fri 8:30 am-11:30 pm  ·  Sat-Sun 10:00 am-11:30 pm",
  },
];

const faqs = [
  {
    q: "How do I book a home doctor visit?",
    a: "Use our online appointment form or call +256 777 114 327. Our team will confirm within 2 hours.",
  },
  {
    q: "What areas do you cover?",
    a: "We primarily serve Kampala and central Uganda, with plans to expand nationally. Contact us to check your area.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept MTN Mobile Money, Airtel Money, Centenary Bank transfer, and cash on service delivery.",
  },
  {
    q: "Do you offer emergency services?",
    a: "Yes - our emergency line is available 24/7. Call +256 777 114 327 for urgent assistance.",
  },
];

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const updateForm = ({ target: { name, value } }) => {
    setForm((current) => ({ ...current, [name]: value }));
  };

  const submitForm = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      await Api.sendContactMessage(form);
      setSubmitted(true);
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Contact message failed:", error);
      window.alert(
        "We could not send your message. Please try again or email mobiledoctor@yitalife.com directly.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <PageSEO
        title="Contact Yitalife - Book a Home Doctor in Uganda"
        description="Contact Yitalife to book a home doctor visit, telemedicine consultation, or corporate health service in Uganda. Reach us by phone, WhatsApp, or email. Located in Makerere Kavule, Kampala. A service of Yita Medical Services (YMS)."
        canonical="https://www.yitalife.com/Contact"
      />

      {/* ── PAGE HERO ── */}
      <div className="page-hero" style={{ backgroundImage: `url(${heroContactImg})` }}>
        <div className="container page-hero-content">
          <h1 data-aos="fade-down">Contact Yitalife</h1>
          <p data-aos="fade-up" data-aos-delay="100">
            We're here to help; reach out any time.
          </p>
          <div className="page-breadcrumb">
            <Link to="/">Home</Link>
            <ion-icon
              name="chevron-forward-outline"
              style={{ fontSize: "13px" }}
            ></ion-icon>
            <span>Contact</span>
          </div>
        </div>
      </div>

      {/* ── MAIN CONTACT SECTION ── */}
      <section className="contact-section">
        <div className="container">
          <div className="row g-5">
            {/* LEFT: info + image + social */}
            <div className="col-lg-4 col-md-12" data-aos="fade-right">
              <div className="contact-info-grid">
                {contactDetails.map((item, i) => (
                  <div className="contact-info-card" key={i}>
                    <div className="contact-info-icon">
                      <ion-icon name={item.icon}></ion-icon>
                    </div>
                    <div className="contact-info-body">
                      <h6>{item.label}</h6>
                      {item.href ? (
                        <p>
                          <a href={item.href}>{item.value}</a>
                        </p>
                      ) : (
                        <p>{item.value}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div
                className="contact-img-wrapper"
                style={{ marginBottom: "20px" }}
              >
                <img
                  src={cont}
                  alt="Yitalife medical team - Yita Medical Services Kampala Uganda"
                  onError={(e) => {
                    e.target.src = contFallback;
                  }}
                />
              </div>

              <p
                style={{
                  fontSize: "13px",
                  color: "var(--text-muted)",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  marginBottom: "10px",
                  textTransform: "uppercase",
                  letterSpacing: "0.8px",
                }}
              >
                Connect with us
              </p>
              <div className="contact-social-row">
                <a
                  href="https://x.com/yitalife"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-social-btn tw"
                >
                  <ion-icon name="logo-twitter"></ion-icon> Twitter
                </a>
                <a
                  href="https://www.facebook.com/yitalife.yms?mibextid=LQQJ4d"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-social-btn fb"
                >
                  <ion-icon name="logo-facebook"></ion-icon> Facebook
                </a>
                <a
                  href="https://wa.me/256777114327"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-social-btn wa"
                >
                  <ion-icon name="logo-whatsapp"></ion-icon> WhatsApp
                </a>
              </div>
            </div>

            {/* RIGHT: form */}
            <div
              className="col-lg-8 col-md-12"
              data-aos="fade-left"
              data-aos-delay="100"
            >
              <div className="contact-form-card">
                {submitted ? (
                  <div style={{ textAlign: "center", padding: "60px 20px" }}>
                    <div
                      style={{
                        fontSize: "64px",
                        color: "var(--teal)",
                        marginBottom: "16px",
                      }}
                    >
                      <ion-icon name="checkmark-circle-outline"></ion-icon>
                    </div>
                    <h3 style={{ marginBottom: "12px" }}>Message Sent!</h3>
                    <p
                      style={{
                        fontSize: "18px !important",
                        color: "var(--text-muted)",
                      }}
                    >
                      Thank you for reaching out. Our team will get back to you
                      within 24 hours.
                    </p>
                    <button
                      onClick={() => setSubmitted(false)}
                      style={{
                        marginTop: "24px",
                        background: "var(--primary)",
                        color: "white",
                        border: "none",
                        padding: "12px 28px",
                        borderRadius: "8px",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 700,
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <>
                    <h3>Send Us a Message</h3>
                    <p>Fill in the form and our team will respond promptly.</p>
                    <form className="contact-form" onSubmit={submitForm}>
                      <div className="form-row">
                        <div className="form-group">
                          <label htmlFor="c-fname">First Name *</label>
                          <input
                            id="c-fname"
                            name="firstName"
                            value={form.firstName}
                            onChange={updateForm}
                            type="text"
                            placeholder="John"
                            autoComplete="given-name"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="c-lname">Last Name</label>
                          <input
                            id="c-lname"
                            name="lastName"
                            value={form.lastName}
                            onChange={updateForm}
                            type="text"
                            placeholder="Doe"
                            autoComplete="family-name"
                          />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group">
                          <label htmlFor="c-email">Email Address *</label>
                          <input
                            id="c-email"
                            name="email"
                            value={form.email}
                            onChange={updateForm}
                            type="email"
                            placeholder="john@example.com"
                            autoComplete="email"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="c-phone">Phone Number</label>
                          <input
                            id="c-phone"
                            name="phone"
                            value={form.phone}
                            onChange={updateForm}
                            type="tel"
                            placeholder="+256 700 000 000"
                            autoComplete="tel"
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="c-subject">Subject</label>
                        <select
                          id="c-subject"
                          name="subject"
                          value={form.subject}
                          onChange={updateForm}
                        >
                          <option value="">Select a topic…</option>
                          <option>Book an Appointment</option>
                          <option>General Inquiry</option>
                          <option>Partnership</option>
                          <option>Emergency</option>
                          <option>Other</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="c-message">Your Message *</label>
                        <textarea
                          id="c-message"
                          name="message"
                          value={form.message}
                          onChange={updateForm}
                          placeholder="Write your message here…"
                          rows={6}
                          required
                        ></textarea>
                      </div>
                      <button
                        type="submit"
                        className="contact-submit-btn"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Sending..." : "Send Message"}
                        <ion-icon name="send-outline"></ion-icon>
                      </button>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FAQ STRIP ── */}
      <section className="contact-faq-strip">
        <div className="container">
          <div
            style={{ textAlign: "center", marginBottom: "48px" }}
            data-aos="fade-up"
          >
            <div
              className="badge-yita"
              style={{
                margin: "0 auto 14px",
                background: "rgba(255,255,255,0.12)",
                color: "rgba(255,255,255,0.9)",
                border: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ion-icon name="help-circle-outline"></ion-icon>
              Common Questions
            </div>
            <h2
              style={{
                color: "var(--white)",
                fontSize: "2rem",
                fontFamily: "Playfair Display, serif",
              }}
            >
              Frequently Asked Questions
            </h2>
          </div>
          <div className="row g-4">
            {faqs.map((f, i) => (
              <div
                className="col-lg-6"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 70}
              >
                <div className="faq-item">
                  <h5>
                    <ion-icon
                      name="chevron-forward-circle-outline"
                      style={{
                        verticalAlign: "middle",
                        marginRight: "8px",
                        color: "#fbbf24",
                      }}
                    ></ion-icon>
                    {f.q}
                  </h5>
                  <p>{f.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── GOOGLE MAPS ── */}
      <section
        className="contact-map-section"
        aria-label="Yitalife Location Map"
      >
        <div className="container">
          <div
            className="text-center"
            style={{ marginBottom: "36px" }}
            data-aos="fade-up"
          >
            <div className="badge-yita" style={{ margin: "0 auto 14px" }}>
              <ion-icon name="location-outline"></ion-icon>
              Find Us
            </div>
            <h2
              style={{
                fontFamily: "Playfair Display, serif",
                fontSize: "2rem",
              }}
            >
              Our Location
            </h2>
            <p
              style={{
                color: "var(--text-muted)",
                maxWidth: "500px",
                margin: "0 auto",
              }}
            >
              Yitalife offices are located at Phlona Medical Chambers, Makerere
              Kavule, Kampala, Uganda. We also serve patients at their homes
              across Uganda.
            </p>
          </div>
          <div
            className="contact-map-wrapper"
            data-aos="fade-up"
            data-aos-delay="80"
          >
            <iframe
              title="Yitalife - Phlona Medical Chambers, Makerere Kavule, Kampala Uganda"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7453!2d32.5635!3d0.3356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbb0d6d04c8ab%3A0x0!2sMakerere+Kavule%2C+Kampala%2C+Uganda!5e0!3m2!1sen!2sug!4v1720000000000!5m2!1sen!2sug"
              width="100%"
              height="420"
              style={{ border: 0, borderRadius: "16px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div
            className="contact-map-details"
            data-aos="fade-up"
            data-aos-delay="120"
          >
            <div className="contact-map-detail-item">
              <ion-icon name="location-outline"></ion-icon>
              <span>
                Phlona Medical Chambers, Makerere Kavule, Kampala, Uganda
              </span>
            </div>
            <div className="contact-map-detail-item">
              <ion-icon name="call-outline"></ion-icon>
              <a href="tel:+256777114327">+256 777 114 327</a>
            </div>
            <div className="contact-map-detail-item">
              <ion-icon name="navigate-outline"></ion-icon>
              <a
                href="https://maps.google.com/?q=Makerere+Kavule+Kampala+Uganda"
                target="_blank"
                rel="noreferrer"
              >
                Get Directions on Google Maps
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
